var CanSwitch = function CanSwitch(props) {
  // console.log("role", props.role);
  switch (props.role) {
    case "coordinator":
      return props.coordinator();

    case "trainer":
      return props.trainer();

    case "parent":
      return props.parent();

    default:
      return props["default"]();
  }
};

CanSwitch.defaultProps = {
  coordinator: function coordinator() {
    return null;
  },
  trainer: function trainer() {
    return null;
  },
  parent: function parent() {
    return null;
  }
};
export { CanSwitch };